(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ct-magazine-pack-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ct-magazine-pack-selector')) return;
    const selections = new Map();

    class CtMagazinePackSelector extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('product-info') || this.closest('.shopify-section') || this.parentElement;
        this.stateKey = this.dataset.productId + ':' + this.dataset.formId;
        this.selectedQuantity = selections.get(this.stateKey) || 1;
        this.events = new AbortController();
        this.pendingRefresh = false;

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-ct-pack-quantity]');
          if (!button || !this.contains(button) || button.disabled) return;

          this.selectedQuantity = Number(button.dataset.ctPackQuantity);
          this.refresh();
        }, { signal: this.events.signal });

        this.scope.addEventListener('change', (event) => {
          if (event.target !== this.quantityInput) this.scheduleRefresh();
        }, { signal: this.events.signal });

        this.scope.addEventListener('click', (event) => {
          if (!this.contains(event.target)) window.setTimeout(() => this.scheduleRefresh(), 0);
        }, { signal: this.events.signal });

        this.scope.addEventListener('submit', (event) => {
          if (event.target === this.form) this.refresh();
        }, { capture: true, signal: this.events.signal });

        this.observer = new MutationObserver((records) => {
          if (records.some((record) => (
            record.type === 'childList'
            || record.target.matches?.('input[name="id"]')
          ))) this.scheduleRefresh();
        });
        this.observer.observe(this.scope, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['value', 'disabled']
        });

        this.scheduleRefresh();
      }

      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.nativeQuantity?.classList.remove('ct-magazine-pack-selector__native-quantity');
        delete this.dataset.ctMagazinePackSelectorReady;
        this.hidden = true;
      }

      scheduleRefresh() {
        if (this.pendingRefresh) return;
        this.pendingRefresh = true;

        queueMicrotask(() => {
          this.pendingRefresh = false;
          if (this.isConnected) this.refresh();
        });
      }

      bindForm() {
        const form = this.scope.querySelector('form[id="' + this.dataset.formId + '"]')
          || this.scope.querySelector('form[data-type="add-to-cart-form"]');
        const variantInput = form?.querySelector('[name="id"]');
        const quantityInput = form?.querySelector('input[name="quantity"]')
          || (form && this.scope.querySelector('input[name="quantity"][form="' + form.id + '"]'));
        const variantData = this.querySelector('[data-ct-magazine-pack-variants]');

        if (!form || !variantInput || !quantityInput || !variantData) return false;

        if (this.variantSource !== variantData.textContent) {
          try {
            const parsed = JSON.parse(variantData.textContent);
            if (!Array.isArray(parsed)) return false;
            this.variants = parsed;
            this.variantSource = variantData.textContent;
          } catch {
            return false;
          }
        }

        const nativeQuantity = quantityInput.closest('.product-form__quantity');
        if (this.nativeQuantity !== nativeQuantity) {
          this.nativeQuantity?.classList.remove('ct-magazine-pack-selector__native-quantity');
        }

        this.form = form;
        this.variantInput = variantInput;
        this.quantityInput = quantityInput;
        this.nativeQuantity = nativeQuantity;
        this.buttons = Array.from(this.querySelectorAll('[data-ct-pack-quantity]'));
        return this.buttons.length === 3;
      }

      setQuantity(quantity) {
        if (Number(this.quantityInput.value) === quantity) return;
        this.quantityInput.value = String(quantity);
        this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      refresh() {
        if (!this.bindForm()) {
          this.hidden = true;
          this.nativeQuantity?.classList.remove('ct-magazine-pack-selector__native-quantity');
          return;
        }

        const variant = this.variants.find((item) => (
          String(item.id) === String(this.variantInput.value)
        ));

        if (!variant) {
          this.hidden = true;
          this.nativeQuantity?.classList.remove('ct-magazine-pack-selector__native-quantity');
          return;
        }

        const tracked = Boolean(variant.inventoryManagement) && variant.inventoryPolicy !== 'continue';
        const stock = tracked ? Math.max(0, Number(variant.inventoryQuantity) || 0) : Infinity;
        const availableQuantities = this.buttons.map((button) => Number(button.dataset.ctPackQuantity))
          .filter((quantity) => Boolean(variant.available) && stock >= quantity);

        if (!availableQuantities.includes(this.selectedQuantity)) {
          this.selectedQuantity = availableQuantities[0] || 1;
        }
        selections.set(this.stateKey, this.selectedQuantity);

        this.buttons.forEach((button) => {
          const quantity = Number(button.dataset.ctPackQuantity);
          const enabled = availableQuantities.includes(quantity);
          const selected = enabled && quantity === this.selectedQuantity;

          button.disabled = !enabled;
          button.classList.toggle('is-selected', selected);
          button.setAttribute('aria-pressed', String(selected));
        });

        this.setQuantity(this.selectedQuantity);
        this.dataset.ctMagazinePackSelectorReady = 'true';
        this.nativeQuantity?.classList.add('ct-magazine-pack-selector__native-quantity');
        this.hidden = false;
      }
    }

    customElements.define('ct-magazine-pack-selector', CtMagazinePackSelector);
  })();
  } catch(e) { console.error(e); }
})();

})();
